import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import { allowedCountryCodes } from './../../../utils/validation';
import * as styles from './PhoneInput.less';

const PhoneInput = props => {
  const [state, setState] = useState({ country: 'us', phone: '1' });
  const handleInputChange = (value, data) => {
    const { countryCode } = data;
    const stripPlus = value.replace(/[^0-9]+/, '');
    props.setFieldValue('phone', stripPlus);
    props.validateField('phone');
    setState({ phone: value, country: countryCode });
  };

  return (
    <ReactPhoneInput
      placeholder=''
      autoFormat={false}
      value={state.phone}
      onChange={handleInputChange}
      inputClass={styles.inputPhone}
      defaultCountry={state.country}
      onlyCountries={allowedCountryCodes}
      dropdownClass={styles.countryDropdown}
      buttonClass={styles.countryDropdownButton}
      disableAreaCodes={true}
    />
  );
};

PhoneInput.propTypes = {
  setFieldValue: PropTypes.func,
  validateField: PropTypes.func,
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/views/components/PhoneInput/PhoneInput.js